import { Box } from '../../../../mads';

import { Image, StyleSheet } from 'react-native';

interface CompanyBannerImageProps {
    url: string;
    companyLogo?: React.ReactNode;
}

export function CompanyBannerImage({ url, companyLogo }: CompanyBannerImageProps) {
    return (
        <Box sx={styles.container}>
            <Image
                source={{ uri: url }}
                style={styles.bannerImage}
                accessibilityRole="image"
                accessibilityLabel="Company banner"
                resizeMode="cover"
            />
            {companyLogo && (
                <Box sx={styles.logoOverlay}>
                    {companyLogo}
                </Box>
            )}
        </Box>
    );
}

const styles = StyleSheet.create({
    container: {
        position: 'relative',
        padding: 4,
        marginTop: -16,
        marginStart: -16,
        marginEnd: -16,
        marginBottom: 8,
    },
    bannerImage: {
        width: '100%',
        height: 100,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2,
    },
    logoOverlay: {
        position: 'absolute',
        bottom: -8,
        left: 12,
    },
});
